import React, { useMemo } from 'react';

import { DailyReportRow } from 'modules/components/layer23';
import { StyledTable } from 'modules/components/layer24';

import * as ds from './dataService';
import { useParams } from 'react-router-dom';



export type DailyReportTableProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DailyReportTableProps) => {
  const headers: string[] = [
    'Report Date',
    'Description',
    'Approved By',
    'Time Approved',
    'Deliveries',
    'Incidents',
    'Inspections',
    'Events Logged'
  ];
  const params = useParams();
  const { data } = ds.useQuery({
    filter: {
      projectId: params.projectId ?? ''
    }
  });
  const rows = useMemo(() => {
    return data.map((node, i) => {
      return (
        <DailyReportRow.FC
          key={i}
          id={node.id}
          events={node.eventCount}
          subcontractors={0}
          date={node.date}
          fullAddress=''
          approvedAt={node.approvedAt?.toFormat('DDDD') ?? ''}
          approvedBy={node.approvedBy}
          description={node.description}
        />
      );
    });
  }, [data]);

  return (
    <StyledTable.FC
      headers={headers}
      rows={rows}
    />

  );
};
